module.exports = __webpack_public_path__ + "40cee661420403a41c2a179147354718.png";